module.exports = __webpack_public_path__ + "img/happy-holidays-30off.4fc20238.png";